import { FormSectionStyled } from './styles/FormSectionStyled'

export const FormSection = FormSectionStyled
